module.exports = __webpack_public_path__ + "img/unauthenticated_cover.9595e503.jpg";